<template>
    <div class="history-list m-auto" v-if="purchases.length > 0">
        <HistoryItem
            v-for="campaign in purchases"
            :key="campaign.id"
            :purchase="campaign"
            @onClickPurchase="clickPurchase(campaign)"
            @onClickViewSlip="clickViewSlip($event)"
            :selectedTab="selectedTab"
        ></HistoryItem>
    </div>
    <div class="text-center mt-7" v-if="isLoaded && !isHaveItem">Not Found</div>

    <Teleport to="body">
        <BottomSheet
            v-model="showPopupSlip"
            :dismissable="true"
            ref="btsPopupSlip"
        >
            <div class="mt-5 mx-9 mb-9">
                <div
                    class="
                        text-center text-lg text-primary
                        leading-normal
                        uppercase
                        mx-6
                        font-
                    "
                >
                    Slip
                </div>
                <div class="text-center mt-6 mb-6 rounded-md">
                    <template v-if="popupSlipImg != null">
                        <img
                            :src="popupSlipImg"
                            class="
                                w-auto
                                h-auto
                                max-w-270px
                                mx-auto
                                shadow-md
                            "
                        />
                    </template>
                </div>
            </div>
            <Footer :hasPoweredBy="false"></Footer>
        </BottomSheet>
    </Teleport>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
// import Util from '@/helper/Utility.js';
import Locale from "@/helper/locale/Locale.js";
import ConfigManager from "@/config/ConfigManager.js";
import { CampaignType } from "@/helper/StaticValue.js";
//component
import HistoryItem from "./HistoryItem.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";
import BottomSheet from "@/components/Dialog/BottomSheet.vue";
//service
import BzbsHistory from "@/core/History/service/BzbsHistory.js";
import BzbsRedeem from "@/core/Redeem/service/BzbsRedeem.js";
import { SerialModel } from "@/core/Redeem/model/SerialModel.js";

// mixin
import LocaleMixin from "@/mixin/LocaleMixin";

export default {
    name: "HistoryList",
    components: {
        HistoryItem,
        BottomSheet,
        Footer,
    },
    mixins: [LocaleMixin],
    props: {
        initListConfig: { type: Object, required: true },
        initFilterConfig: { type: Object, required: true },
        modalController: { type: Object, required: true },
        selectedTab: Number,
    },
    data: function () {
        return {
            purchases: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            isSerialLoading: false,
            showPopupSlip: false,
            popupSlipImg: null,
        };
    },
    created: function () {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;
    },
    methods: {
        //#region history list
        reinitList: function (listConfig, listFilter) {
            this.listConfig = listConfig;
            this.filterConfig = listFilter;
            this.purchases = [];
            this.getList();
        },
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHistory.apiGetPurchase(
                    this.listConfig,
                    this.filterConfig
                ).subscribe(
                    (purchases) => {
                        // Util.log('history list', purchases);

                        //check is there are more campaign.
                        if (
                            purchases &&
                            purchases.length < this.listConfig.defaultTopAmount
                        ) {
                            this.listConfig.setSeeMoreEnable(false);
                        }

                        this.listConfig.increstSkip();
                        // reinitialize list if no skip.
                        if (
                            this.listConfig.intSkip ==
                            this.listConfig.defaultTopAmount
                        ) {
                            this.purchases = [];
                        }

                        this.purchases = this.purchases.concat(purchases);

                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem =
                            this.purchases.length > 0 ? true : false;
                        resolve();
                    },
                    (err) => {
                        resolve();
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.errorApi(err, true, {
                            title: this.lbl.default.error,
                        });
                    }
                );
            });
        },

        loadMore: function () {
            if (!this.listConfig.isSeeMoreEnable) {
                return;
            }

            if (this.isLoading) {
                return;
            }
            this.getList();
        },
        //#endregion history list

        //#region action history
        clickViewSlip: function (purchase) {
            let info1 = purchase.info1 ?? null;
            if (info1 != null) {
                let json = JSON.parse(info1)
                const imgUrl =  json.find((item) => {
                    if(Object.keys(item) == 'image_url'){
                        return item;
                    }
                });
                this.popupSlipImg = imgUrl.image_url ?? ""
                // console.log(this.popupSlipImg)
                this.$refs.btsPopupSlip.show();
            }
        },

        clickPurchase: function (purchase) {
            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }

            // this.clickedIndex = index;

            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }

            // if (purchase.isUsed == false && purchase.isNotAutoUse == false) {
            //     this.initialUsedSerial(purchase);
            // } else if (purchase.isUsed == true && purchase.isNotAutoUse == false) {
            //     this.callApiRedeemUse(purchase);
            // } else {
                this.callApiRedeemUse(purchase);
            // }

        },
        initialUsedSerial: function(purchase) {
            this.modalController.confirmUsedModal
                .clearModal()
                .setCampaign(purchase)
                .show();
            this.modalController.confirmUsedModal.onClickOk(() => {
                this.callApiRedeemUse(purchase);
            })
        },

        callApiRedeemUse: function(purchase) {
            this.isSerialLoading = true;
            BzbsHistory.apiRedeemUse(purchase.redeemKey).subscribe(
                (result) => {
                    this.isSerialLoading = false;
                    // this.purchases[this.clickedIndex].updateAfterRedeem(result);
                    purchase.updateAfterRedeem(result);

                    // var tmpPurchase = this.purchases[this.clickedIndex];
                    if (this.isShowSerialModal(purchase)) {
                        // this.busSerialModal.$emit('showSerialModal', purchase);
                        this.openSerial(purchase);
                    } else {
                        this.refreshList();
                        this.getList();
                    }
                    // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)
                    // else {
                    //     this.refreshList();
                    // }
                },
                (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                }
            );
        },

        openSerial: function (purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            this.modalController.serialModal
                .clearModal()
                .setSerial(serialModel)
                .setHistoryBtn(false)
                .show();
            this.modalController.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.$emit("onRefreshList");
            });
            this.modalController.serialModal.onCloseModal(async() => {
                this.$emit("onRefreshList");
            });
            this.modalController.serialModal.onSlideToUsed(() => {
                this.arrangeRedeem(purchase.redeemKey);
            });
        },

        arrangeRedeem: function (redeemKey) {
            BzbsRedeem.apiArrangeRedeem(redeemKey).subscribe({
                next: () => {
                    this.modalController.serialModal.hide();
                    this.$emit("onRefreshList");
                },
                error: (err) => {
                    console.log(err);
                }
            })
        },

        openInterfaceHistory: function (purchase) {
            var sToken = Account.getTokenShuffle();
            var locale = Locale.getLocaleCode();
            var header = "false";
            var theme = ConfigManager.getAppName();
            var returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == "link") {
                var url = purchase.privilegeMessage;

                url = url.replace("<campaign_id>", purchase.id);
                url = url.replace("<token>", sToken);
                url = url.replace("<serial>", purchase.serial);
                url = url.replace("<locale>", Locale.getLocaleCode());

                url += "&return_url=" + returnUrl;

                window.location.replace(url);
                return;
            }

            // old default landing interface
            if (purchase.website && purchase.website.indexOf("starbucks") > 0) {
                let url =
                    purchase.website +
                    "&token=" +
                    sToken +
                    "&locale=" +
                    locale +
                    "&RedeemKey=" +
                    purchase.redeemKey +
                    "&header=" +
                    header +
                    "&theme=" +
                    theme +
                    "&return_url=" +
                    returnUrl; // ReturnUrl;
                window.location.replace(url);
            } else if (
                purchase.website &&
                purchase.website.indexOf("linesticker") > 0
            ) {
                let url =
                    purchase.website +
                    "&info2=" +
                    purchase.info2 +
                    "&info3=" +
                    purchase.info3 +
                    "&locale=" +
                    locale +
                    "&return_url=" +
                    encodeURIComponent(window.location.href) +
                    "&token=" +
                    sToken +
                    "&is_history=true";
                window.location.replace(url);
            }
        },

        isShowSerialModal: function (purchase) {
            if (purchase.serial === "XXXXXXX") {
                return false;
            }
            if (purchase.expireIn && purchase.expireIn <= 0) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get") return false;

                return true;
            }

            if (
                purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy
            ) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },

        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then(() => {
                this.purchases = tmp;
            });
        },
        //#endregion action history
    },
};
</script>
<style lang="scss" scoped>
.history-list {
    max-width: 500px;
}
</style>
